import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Navbar.css";

export default function CimentoNavbar({ user, logout, tab, setTab, canEnter, canTrack, canShipmentControl, canParameters, canAssign, canFormen, canApproveBindings, canViewOrders, bindingApprovalCount }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const menuRef = useRef(null);
  useEffect(() => setOpen(false), [tab]);
  useEffect(() => {
    const closeOutside = (event) => {
      if (event.target.closest?.(".hamburger")) return;
      if (menuRef.current && !menuRef.current.contains(event.target)) setOpen(false);
    };
    document.addEventListener("mousedown", closeOutside);
    return () => document.removeEventListener("mousedown", closeOutside);
  }, []);
  const go = (next) => { setTab(next); setOpen(false); };
  return <nav className="navbar">
    <div className="navbar-left" onClick={() => go(canEnter ? "giris" : canTrack ? "ozet" : canShipmentControl ? "sevkiyat-kontrol" : canFormen ? "formen" : "parametre")}>
      <img src="/logo.png" alt="logo" className="navbar-logo" />
      <span className="navbar-title">Çimento Operasyonu</span>
    </div>
    {user && <><div className="hamburger" onClick={() => setOpen(!open)}><span></span><span></span><span></span></div><div ref={menuRef} className={`navbar-links ${open ? "show" : ""}`}>
      {canEnter && <button className={`navbar-link ${tab === "giris" ? "active" : ""}`} onClick={() => go("giris")}>Şoför Girişi</button>}
      {canTrack && <button className={`navbar-link ${tab === "rapor" ? "active" : ""}`} onClick={() => go("rapor")}>Sevkiyat Raporu</button>}
      {canTrack && <button className={`navbar-link ${tab === "ozet" ? "active" : ""}`} onClick={() => go("ozet")}>Günlük Özet</button>}
      {canViewOrders && <button className={`navbar-link ${tab === "siparisler" ? "active" : ""}`} onClick={() => go("siparisler")}>Bağlantı Siparişleri</button>}
      {canApproveBindings && <button className={`navbar-link ${tab === "baglama-onay" ? "active" : ""}`} onClick={() => go("baglama-onay")}>Bağlama Onayları{bindingApprovalCount ? ` (${bindingApprovalCount})` : ""}</button>}
      {canShipmentControl && <button className={`navbar-link ${tab === "sevkiyat-kontrol" ? "active" : ""}`} onClick={() => go("sevkiyat-kontrol")}>Sevkiyat Kontrolü</button>}
      {canFormen && <button className={`navbar-link ${tab === "formen" ? "active" : ""}`} onClick={() => go("formen")}>Formen Kontrolü</button>}
      {(canParameters || canAssign) && <button className={`navbar-link ${tab === "parametre" ? "active" : ""}`} onClick={() => go("parametre")}>Parametreler</button>}
      <button className="navbar-link" onClick={() => navigate("/secilen-proje")}>🔁 Proje Seç</button>
      <button className="logout-button" onClick={async () => { await logout(); navigate("/"); }}>Çıkış</button>
    </div></>}
  </nav>;
}
